import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:5000";

export const submitApplication = (formData) => {
  return axios.post(`${API_BASE}/api/applicants`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const adminLogin = (username, password) =>
  axios.post(`${API_BASE}/api/admin/login`, { username, password });

export const getApplicants = (token, eligible) =>
  axios.get(
    `${API_BASE}/api/admin/applicants${
      eligible === undefined ? "" : "?eligible=" + eligible
    }`,
    { headers: { Authorization: `Bearer ${token}` } }
  );

export const exportCsv = (token, eligible) =>
  axios.get(
    `${API_BASE}/api/admin/export${
      eligible === undefined ? "" : "?eligible=" + eligible
    }`,
    { headers: { Authorization: `Bearer ${token}` }, responseType: "blob" }
  );

export const updateApplicant = (token, id, updates) =>
  axios.put(`${API_BASE}/api/admin/applicants/${id}`, updates, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAuditLogs = (token, params = {}) => {
  const queryParams = new URLSearchParams();
  
  if (params.action) queryParams.append("action", params.action);
  if (params.adminUsername) queryParams.append("adminUsername", params.adminUsername);
  if (params.resourceId) queryParams.append("resourceId", params.resourceId);
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  
  const queryString = queryParams.toString();
  return axios.get(
    `${API_BASE}/api/admin/audit-logs${queryString ? `?${queryString}` : ""}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
};

export const getApplicantAuditLogs = (token, applicantId) =>
  axios.get(`${API_BASE}/api/admin/audit-logs/applicant/${applicantId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
